import { type Dispatch } from 'react'

import { ActionItem, Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import ScrollableItem from 'modules/core/components/ScrollableItem'

import type { CommunitiesDropdown } from 'modules/dashboard/components/Groups/types'

interface GroupItemProps {
  group: CommunitiesDropdown
  onSelect: Dispatch<CommunitiesDropdown>
  selected: boolean
}

const GroupItem = observer(({ selected, group, onSelect }: GroupItemProps) => {
  const handleSelect = () => {
    onSelect(group)
  }

  return (
    <ScrollableItem>
      <ActionItem onClick={handleSelect} selected={selected} showIcon={false}>
        <Box textAlign="left">
          <Text.Normal weight="medium">{group.title}</Text.Normal>
        </Box>
      </ActionItem>
    </ScrollableItem>
  )
})

export default GroupItem
